export default __webpack_public_path__ + "static/media/minimize.43c6164d.svg";